// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}


import tabbing from './modules/tabbing';
import skip from './modules/skip';
import nav from './modules/nav';
import dropdowns from './modules/dropdowns';
import filters from './modules/filters';
import videos from './modules/videos';
import accordion from './modules/accordion';
import progress from './modules/progress-bar';
import underline from './modules/underline';
import backToTop from './modules/back-to-top';
import parallaxImage from './modules/parallax-image';

tabbing();
skip();
nav();
dropdowns();
filters();
videos();
accordion();
progress();
backToTop();
parallaxImage();

const rootEL = document.documentElement;
rootEL.classList.remove('no-js');

// document.addEventListener('DOMContentLoaded', function(e) {
//   document.body.classList.remove('page-is-loading');
// });

window.addEventListener('load', function(e) {
  document.body.classList.remove('page-is-loading');
  underline();
});

